export default __webpack_public_path__ + "static/media/whatsapp_chat_background.7e014094.jpg";